import { render, staticRenderFns } from "./WorkGroupsView.vue?vue&type=template&id=61409f93&scoped=true"
import script from "./WorkGroupsView.vue?vue&type=script&lang=js"
export * from "./WorkGroupsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61409f93",
  null
  
)

export default component.exports